module.exports = __webpack_public_path__ + "static/media/comment-single-tick.d46c6d98.svg";